"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatGPT = void 0;
var helper_1 = require("../../helper");
var object_service_1 = require("../../object-service");
var variables_const_1 = require("../../variables.const");
var ChatGPT = /** @class */ (function () {
    function ChatGPT() {
        this.helper = object_service_1.ObjectService.getInstance(helper_1.Helper);
        this.freshConversation = true;
        this.stylesAdded = false;
    }
    ChatGPT.prototype.loadModule = function () {
        var _this = this;
        this.addDocumentStyles();
        var chatGPTContainer = $('#chatgpt');
        if (chatGPTContainer.length === 0) {
            console.error('You have chatgpt widget includede but no form');
            return;
        }
        chatGPTContainer.addClass('chatGPTContainer').addClass('dimensions');
        var textarea = chatGPTContainer.find('textarea').css('width', '100%');
        textarea.addClass('dimensions');
        var button = chatGPTContainer.find('.w-button');
        var displayContentAboveTextarea = function (content, className) {
            var $hardcodedSpan = $('<span></span>')
                .css('padding', '4px')
                .css('font-size', '1.5rem')
                .text(className === 'answer-c' ? 'A' : 'Q');
            var $contentSpan = $('<span></span>').text(content);
            var $contentDiv = $('<div></div>')
                .addClass('response-content')
                .addClass(className)
                .append($hardcodedSpan)
                .append($contentSpan);
            if (className === 'answer-c') {
                var thumbUp = $('<img class="thumb" title="Good answer" src="' +
                    variables_const_1.assetsUrl +
                    '/thumb.svg"/>');
                var thumbDown = $('<img class="thumb" title="Wrong or unhelpful answer" style="margin-top:15px;transform:rotate(180deg)" src="' +
                    variables_const_1.assetsUrl +
                    '/thumb.svg"/>');
                thumbUp.on('click', function () {
                    console.log('thumb up');
                    sendRequest('good');
                });
                thumbDown.on('click', function () {
                    console.log('thumb down');
                    sendRequest('bad');
                });
                var thumbs = $('<div></div>')
                    .addClass('thumbs')
                    .append(thumbUp)
                    .append(thumbDown);
                $contentDiv.append(thumbs);
            }
            textarea.before($contentDiv);
        };
        var startTyping = function () {
            var $contentSpan = $('<span></span>')
                .css('margin-left', '25px')
                .text('Assistent tippt gerade');
            var typewriter = $('<div class="snippet" data-title="dot-pulse"><div class="stage"><div class="dot-pulse"></div></div></div>');
            $contentSpan.append(typewriter);
            var $contentDiv = $('<div></div>')
                .addClass('response-content')
                .addClass('assistant-typing')
                .append($contentSpan);
            textarea.before($contentDiv);
        };
        var stopTyping = function () {
            $('.assistant-typing').remove();
        };
        var sendRequest = function (type) {
            var data = {
                tenantKey: variables_const_1._settings.tenantKey,
            };
            if (type === 'simple') {
                data.contentKey = textarea[0].value;
            }
            else {
                data.contentKey = _this.lastRequest;
                if (type === 'bad') {
                    data.operation = 'badAnswer';
                }
                else if (type === 'good') {
                    data.operation = 'goodAnswer';
                }
            }
            if (_this.freshConversation === true) {
                data.operation = 'forget';
            }
            performRequest(data);
        };
        var performRequest = function (data) {
            displayContentAboveTextarea(data.contentKey, 'question-c');
            setTimeout(function () {
                startTyping();
            }, 1000);
            if (localStorage.getItem('Location')) {
                data['studioId'] = localStorage.getItem('Location');
            }
            _this.lastRequest = data.contentKey;
            $.ajax({
                url: 'https://files.scaleyourgym.com/files/webflow/new-magicline/dev-php/chat-prod/main.php',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(data),
                xhrFields: {
                    withCredentials: true,
                },
                success: function (response) {
                    displayContentAboveTextarea(response.answer, 'answer-c');
                    _this.freshConversation = false;
                    stopTyping();
                },
                error: function (error) {
                    // Handle error response
                    console.error('Error:', error);
                    stopTyping();
                },
            });
        };
        // When "Enter" key is pressed inside textarea
        textarea.on('keydown', function (e) {
            if (e.keyCode == 13 && !e.shiftKey) {
                // Check for "Enter" key and make sure "Shift" key isn't pressed
                e.preventDefault(); // Prevents new line from being added
                e.stopImmediatePropagation(); // Prevents new line from being added
                sendRequest('simple');
            }
        });
        // When button is clicked
        button.on('click', function () {
            sendRequest('simple');
        });
    };
    ChatGPT.prototype.addDocumentStyles = function () {
        if (this.stylesAdded === false) {
            $('<style>')
                .prop('type', 'text/css')
                .html("\n.chatGPTContainer{\nposition: fixed;\nbottom: 75px;\nleft: 30px;\n}\n.dimensions{\nmargin: 0px;\nmin-width: 250px;\nmax-width: 400px;\n}\n\n@-webkit-keyframes slide-in-left {\n0% {\n-webkit-transform: translateX(-50px);\ntransform: translateX(-50px);\nopacity: 0;\n}\n100% {\n-webkit-transform: translateX(0);\ntransform: translateX(0);\nopacity: 1;\n}\n}\n@keyframes slide-in-left {\n0% {\n-webkit-transform: translateX(-50px);\ntransform: translateX(-50px);\nopacity: 0;\n}\n100% {\n-webkit-transform: translateX(0);\ntransform: translateX(0);\nopacity: 1;\n}\n}\n\n.response-content{\ndisplay:flex;\nalign-items:center;\npadding:4px;\nbackground:#333;\nmargin: 4px 0;\ntransition: all .1s;\n-webkit-animation: slide-in-left 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\nanimation: slide-in-left 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n}\n.snippet{\ndisplay: inline-block;\nmargin-left: 20px;\nmargin-top: 0px;\ntransform: translateY(4px) scale(0.8);\n}\n.dot-pulse {\nposition: relative;\nleft: -9999px;\nwidth: 10px;\nheight: 10px;\nborder-radius: 5px;\nbackground-color: #9880ff;\ncolor: #9880ff;\nbox-shadow: 9999px 0 0 -5px;\nanimation: dot-pulse 1.5s infinite linear;\nanimation-delay: 0.25s;\n}\n.dot-pulse::before, .dot-pulse::after {\ncontent: \"\";\ndisplay: inline-block;\nposition: absolute;\ntop: 0;\nwidth: 10px;\nheight: 10px;\nborder-radius: 5px;\nbackground-color: #9880ff;\ncolor: #9880ff;\n}\n.dot-pulse::before {\nbox-shadow: 9984px 0 0 -5px;\nanimation: dot-pulse-before 1.5s infinite linear;\nanimation-delay: 0s;\n}\n.dot-pulse::after {\nbox-shadow: 10014px 0 0 -5px;\nanimation: dot-pulse-after 1.5s infinite linear;\nanimation-delay: 0.5s;\n}\n\n@keyframes dot-pulse-before {\n0% {\nbox-shadow: 9984px 0 0 -5px;\n}\n30% {\nbox-shadow: 9984px 0 0 2px;\n}\n60%, 100% {\nbox-shadow: 9984px 0 0 -5px;\n}\n}\n@keyframes dot-pulse {\n0% {\nbox-shadow: 9999px 0 0 -5px;\n}\n30% {\nbox-shadow: 9999px 0 0 2px;\n}\n60%, 100% {\nbox-shadow: 9999px 0 0 -5px;\n}\n}\n@keyframes dot-pulse-after {\n0% {\nbox-shadow: 10014px 0 0 -5px;\n}\n30% {\nbox-shadow: 10014px 0 0 2px;\n}\n60%, 100% {\nbox-shadow: 10014px 0 0 -5px;\n}\n}\n\n.thumbs{\nmin-width: 30px;\ndisplay: flex;\nheight: 100%;\nmargin-left:10px;\nposition: relative;\nflex-direction: column;\n}\n\n.thumbs img{\nwidth:25px;\ncursor:pointer;\n}\n.thumbs img:hover{\nopacity: 0.8;\n}\n")
                .appendTo('head');
            this.stylesAdded = true;
        }
    };
    return ChatGPT;
}());
exports.ChatGPT = ChatGPT;
